import { render } from "./footer.vue?vue&type=template&id=60df04d0&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=60df04d0&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60df04d0"]])

export default __exports__